import { ScheduleMatchup } from '@/entities';

import { TeamMatchupCard } from './TeamMatchupCard';

interface Props {
	currentMatchups: ScheduleMatchup[];
	upcomingMatchups: ScheduleMatchup[];
}

export const CurrentAndUpcomingMatchupsContainer = ({ currentMatchups, upcomingMatchups }: Props) => {
	return (
		<div>
			{/* Currently Playing Section */}
			{currentMatchups.length !== 0 && (
				<div className="mt-6">
					<h2 className="text-lg font-bold leading-7 text-gray-900 mb-4">Currently Playing</h2>
					<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 xl:gap-6">
						{currentMatchups.map((matchup) => (
							<TeamMatchupCard key={matchup.uuid} matchup={matchup} areCurrentMatchupsShown />
						))}
					</div>
				</div>
			)}

			{/* Upcoming Section */}
			{upcomingMatchups.length !== 0 && (
				<div className="mt-5">
					<h2 className="text-lg font-bold leading-7 text-gray-900 mb-4">Upcoming</h2>
					<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
						{upcomingMatchups.map((matchup) => (
							<TeamMatchupCard key={matchup.uuid} matchup={matchup} areCurrentMatchupsShown={false} />
						))}
					</div>
				</div>
			)}
		</div>
	);
};
